class FcmSavings extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    if (!this.section) return;
    this.onProductSelect = this.onProductSelect.bind(this);
    this.section.addEventListener('shopify:product:select', this.onProductSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:product:select', this.onProductSelect);
  }

  onProductSelect(event) {
    if (!(event.target instanceof Element) || event.target.closest('product-card') || !event.promise) return;
    event.promise.then(({ detail }) => {
      const html = detail?.html;
      if (!html) return;
      const fresh = html.querySelector(`fcm-savings[data-block-id="${this.dataset.blockId}"]`);
      if (!fresh) return;
      this.innerHTML = fresh.innerHTML;
      this.toggleAttribute('data-empty', !this.textContent.trim());
    }).catch(() => {});
  }
}
if (!customElements.get('fcm-savings')) customElements.define('fcm-savings', FcmSavings);
